"use client";
import NewsLetter from "@/components/newsletter/NewsLetter";
import "./style.css";
import Breadcrumbs from "@/components/breadCrumbAndButton/BreadCrumbAndButton";
const insights = [
  {
    title: "10k+",
    description: "Unique Users Monthly",
  },
  {
    title: "9",
    description: "Languages Published",
  },
  {
    title: "10k+",
    description: "Newsletter Subscribers",
  },
  {
    title: "2x Reach",
    description: "Ads shared across platforms.",
  },
];
export default function AdvertisingClientPage() {
  return (
    <>
      <div className="gh-container top-header-page-padding">
        <main className="post-page-wrapper custom-advertising-template pb-5">
          <article className="post-page post tag-hash-extended-header">
            <Breadcrumbs
              items={[{ label: "Home", href: "/" }, { label: "Advertising" }]}
            />

            <div className="post-head mt-3">
              <div className="post-head-wrapper page-head-wrapper">
                <picture>
                  <source
                    srcSet="/content/images/2025/12/Advertising---coinccino.webp 1600w, https://cdn.coinccinos.com/content/images/size/w1200/format/webp/2025/12/Advertising---coinccino.webp 1200w, https://cdn.coinccinos.com/content/images/size/w1000/format/webp/2025/12/Advertising---coinccino.webp 1000w, /content/images/size/w800/format/webp/2025/12/Advertising---coinccino.webp 800w, https://cdn.coinccinos.com/content/images/size/w500/format/webp/2025/12/Advertising---coinccino.webp 500w"
                    sizes="(min-width: 816px) 736px, 90vw"
                    type="image/webp"
                  />

                  <img
                    srcSet="/content/images/2025/12/Advertising---coinccino.webp 1600w, https://cdn.coinccinos.com/content/images/size/w1200/2025/12/Advertising---coinccino.webp 1200w, https://cdn.coinccinos.com/content/images/size/w1000/2025/12/Advertising---coinccino.webp 1000w, https://cdn.coinccinos.com/content/images/size/w800/2025/12/Advertising---coinccino.webp 800w, /content/images/size/w500/2025/12/Advertising---coinccino.webp 500w"
                    sizes="(min-width: 816px) 736px, 90vw"
                    src="/content/images/2025/12/Advertising---coinccino.webp"
                    alt="Advertising | coinccino"
                    className="post-feature-image"
                  />
                </picture>

                <div className="post-head-content">
                  <div className="post-head-content-container">
                    <h1 className="post-page-title">Advertising</h1>
                    <p className="post-page-excerpt">
                      If you are interested in discussing new opportunities,
                      please contact us by sending an email to
                      marketing@coinccinos.com
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="post-main-wrapper ">
              <div className="post-page-main">
                <div className="post-content">
                  <h2 id="why-advertise-with-coinccino" className="pt-5">
                    Why Advertise with coinccino?
                  </h2>

                  <div className="insights-container py-5">
                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                      {insights.map((item, index) => (
                        <div className="col" key={index}>
                          <div className="kg-product-card">
                            <div className="kg-product-card-container">
                              <div className="kg-product-card-title-container">
                                <h4 className="kg-product-card-title">
                                  <span style={{ whiteSpace: "pre-wrap" }}>
                                    {item.title}
                                  </span>
                                </h4>
                              </div>

                              <div className="kg-product-card-description">
                                <p>
                                  <span style={{ whiteSpace: "pre-wrap" }}>
                                    {item.description}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="content-holder ">
                    <div className="row">
                      <div className="col-12 col-xxl-6">
                        <h2 id="display-advertising" className="py-2">
                          Display Advertising
                        </h2>
                        <p>
                          Boost your brand within the crypto &amp; Web3 space
                          with banners, native ads, and sponsored placements in
                          a trusted editorial environment.
                        </p>

                        <h2 id="press-releases" className="py-2">
                          Press Releases
                        </h2>
                        <p>
                          Distribute press releases on coinccino and partner
                          outlets. Ideal for project launches, events, market
                          insights, or educational content.
                        </p>
                        <ul>
                          <li>
                            Featured on{" "}
                            <strong>
                              European Blockchain Convention, TechBullion,
                              Blockchain Week Rome, ETHRome
                            </strong>{" "}
                            &amp; more
                          </li>
                          <li>Boost visibility and referral traffic.</li>
                        </ul>

                        <h2 id="sponsored-posts" className="py-2">
                          Sponsored Posts
                        </h2>
                        <p>
                          Reach a targeted, engaged audience with sponsored
                          content published on coinccino, supported by in-depth
                          analysis and distribution via social channels and
                          aggregators.
                        </p>
                        <ul>
                          <li>
                            Distributed on top of aggregators -{" "}
                            <strong>Cryptopanic</strong>,{" "}
                            <strong>Blockchair</strong>,{" "}
                            <strong>Blogarama</strong>,{" "}
                            <strong>Google News </strong>
                            &amp; more.
                          </li>
                          <li>High engagement &amp; Credibility</li>
                        </ul>

                        <h2 id="product-service-review" className="py-2">
                          Product Service / Review
                        </h2>
                        <p>
                          Professional reviews of your product or service:
                          exchanges, wallets, tokens, DeFi projects, NFT
                          platforms — with focus on usability, value, and market
                          positioning.
                        </p>

                        <h2 id="hire-a-content-writer" className="py-2">
                          Hire a Content Writer
                        </h2>
                        <p>
                          Get hiquality, crypto-focused content written by
                          experienced writers: articles, guides, SEO-optimized
                          reports to maximize reach and impact.
                        </p>

                        <div className="section-things-to-know py-0">
                          <div className="">
                            <h2 className="">Important Information</h2>

                            <div className="row g-4">
                              {/* <!-- Card 1 --> */}
                              <div className="col-lg-6 col-md-6 important-info-card">
                                <div className="card h-100 shadow-sm ">
                                  <div className="card-body">
                                    <h5 className="card-title">
                                      Payment Methods
                                    </h5>
                                    <p className="card-text">
                                      We accept BTC, ETH, USDT, PayPal, and Bank
                                      Transfer. Other options available upon
                                      request.
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* <!-- Card 2 --> */}
                              <div className="col-lg-6 col-md-6">
                                <div className="card h-100 shadow-sm">
                                  <div className="card-body">
                                    <h5 className="card-title">Contact</h5>

                                    <a
                                      href="mailto:marketing@coinccinos.com"
                                      className="d-block mb-2 text-decoration-none"
                                    >
                                      marketing@coinccinos.com
                                    </a>

                                    <a
                                      href="mailto:info@coinccinos.com"
                                      className="d-block text-decoration-none"
                                    >
                                      info@coinccinos.com
                                    </a>
                                  </div>
                                </div>
                              </div>

                              {/* <!-- Card 3 --> */}
                              <div className="col-12">
                                <div className="card h-100 shadow-sm">
                                  <div className="card-body">
                                    <h5 className="card-title">
                                      Request a Quote and Service Information
                                    </h5>
                                    <p className="card-text">
                                      Get in touch with our team to request a
                                      tailored quote and discover how our
                                      solutions can be customised to suit your
                                      specific requirements.
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* <!-- Card 4 --> */}
                              <div className="col-12">
                                <div className="card h-100 shadow-sm">
                                  <div className="card-body">
                                    <h5 className="card-title">
                                      Guidelines for Content Submission
                                    </h5>
                                    <ul className="mb-0">
                                      <li>
                                        Please make sure your article is
                                        entirely original, written by a human,
                                        and offers genuine value to our readers.
                                      </li>
                                      <li>
                                        We strictly allow only no-follow links.
                                        Irrelevant or spam links will lead to
                                        rejection.
                                      </li>
                                      <li>
                                        Once payment is confirmed, your article
                                        will be published within 48 hours.
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        id="global-audience-section"
                        className="section audience col-12 col-xxl-6"
                      >
                        <div className="container">
                          <div className="content">
                            <h1 className="pt-5">Global Audience</h1>
                            <p>
                              A globally connected and savvy audience sharing a
                              common interest in how crypto is impacting the
                              world.
                            </p>
                            <h3 id="audience-stats" className="mt-4">
                              Audience Stats
                            </h3>

                            <div className="row g-3">
                              {[
                                ["10k+", "Avg. Users / Mo."],
                                ["15k+", "Avg. Views / Mo"],
                                ["10k+", "Email Subscribers"],
                                ["2.4", "Pages per Visit"],
                                ["54.7%", "Bounce Rate"],
                                ["15k+", "Social Followers"],
                              ].map(([value, label], i) => (
                                <div className="col-12 col-md-4" key={i}>
                                  <div className="card h-100 text-center shadow-sm">
                                    <div className="card-body">
                                      <h4 className="fw-bold mb-1">{value}</h4>
                                      <small className="text-muted">
                                        {label}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>

                            <h3 id="demographics" className="mt-5">
                              Demographics
                            </h3>

                            <div className="row g-3">
                              {[
                                ["58%", "Americas / Europe"],
                                ["56%", "Ages 18–34"],
                                ["73%", "Male"],
                              ].map(([value, label], i) => (
                                <div className="col-12 col-md-4" key={i}>
                                  <div className="card h-100 text-center shadow-sm">
                                    <div className="card-body">
                                      <h4 className="fw-bold mb-1">{value}</h4>
                                      <small className="text-muted">
                                        {label}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>

                            <p>
                              <em>
                                * Data via Plausible / Updated: November 2025
                              </em>
                            </p>

                            <figure className="kg-card kg-image-card kg-card-hascaption">
                              <img
                                src="https://cdn.coinccinos.com/content/images/2025/11/coinccino-Coverage.webp"
                                className="kg-image"
                                alt="* Data via Plausible / Updated: November 2025"
                                loading="lazy"
                                width="1200"
                                height="633"
                                srcSet="https://cdn.coinccinos.com/content/images/size/w600/2025/11/coinccino-Coverage.webp 600w, https://cdn.coinccinos.com/content/images/size/w1000/2025/11/coinccino-Coverage.webp 1000w, https://cdn.coinccinos.com/content/images/2025/11/coinccino-Coverage.webp 1200w"
                                sizes="(min-width: 720px) 720px"
                                data-categories="unclassified"
                              />
                              <figcaption>
                                <i>
                                  <em
                                    className="italic"
                                    style={{ whiteSpace: "pre-wrap" }}
                                  >
                                    * Data via Plausible / Updated: October 2025
                                  </em>
                                </i>
                              </figcaption>
                            </figure>

                            <h3
                              id="top-countries-by-web-traffic"
                              className="mt-5"
                            >
                              Top Countries By Web Traffic
                            </h3>

                            <div className="row g-3">
                              {[
                                ["22.6%", "Italy 🇮🇹"],
                                ["50.29%", "USA 🇺🇸"],
                                ["11.5%", "Singapore 🇸🇬"],
                                ["58.50%", "India 🇮🇳"],
                                ["4%", "Poland 🇵🇱"],
                                ["3.7%", "Germany 🇩🇪"],
                                ["3.5%", "France 🇫🇷"],
                                ["3%", "United Kingdom 🇬🇧"],
                                ["2.6%", "Indonesia 🇮🇩"],
                              ].map(([value, country], i) => (
                                <div className="col-12 col-md-4" key={i}>
                                  <div className="card h-100 text-center shadow-sm">
                                    <div className="card-body">
                                      <h4 className="fw-bold mb-1">{value}</h4>
                                      <small className="text-muted">
                                        {country}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
      <NewsLetter />
    </>
  );
}
